import { render, staticRenderFns } from "./ECatalogueHeader.vue?vue&type=template&id=a5cf6608&scoped=true"
import script from "./ECatalogueHeader.vue?vue&type=script&lang=js"
export * from "./ECatalogueHeader.vue?vue&type=script&lang=js"
import style0 from "./ECatalogueHeader.vue?vue&type=style&index=0&id=a5cf6608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cf6608",
  null
  
)

export default component.exports